import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Pagetop from '../components/Pagetop/Pagetop';
import Footer from '../components/Footer/Footer';
import Allevent from '../components/Allevent/Allevent';

class Eventpage extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar title="Events" />
                <Pagetop title="Events"/>
                <Allevent/>
                <Footer/>
                
            </div>
        );
    }
}

export default Eventpage;